import React from 'react';

import {
  CreateUpdateEstimateItemDto,
  GetPositionDto,
  GetProfileDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import CurrencyControl from '../../../app/components/CurrencyControl';

import { isFieldHidden } from './CommissionService';
import ProfileFieldName from './ProfileFieldName';

interface SpecialSalesParamsProps {
  estimateItem: CreateUpdateEstimateItemDto;
  profile?: GetProfileDto;
  position?: GetPositionDto;
  readonly?: boolean;
  lang: string;
  propertyChange?: (obj: Partial<CreateUpdateEstimateItemDto>) => void;
}

export const SpecialSalesParams: React.FC<SpecialSalesParamsProps> = props => {
  const schema = props.profile?.schema;

  const propertyChange = (obj: Partial<CreateUpdateEstimateItemDto>) => {
    if (props.propertyChange) {
      props.propertyChange(obj);
    }
  };

  return (
    <>
      {schema?.serviceExternalWorkPercent &&
        !isFieldHidden(
          'serviceExternalWorkPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="serviceExternalWorkPercent"
            schema={schema?.serviceExternalWorkPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.serviceExternalWorkPercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  serviceExternalWorkPercent: value,
                })
              }
            />
          </ProfileFieldName>
        )}

      {schema?.serviceCreationPercent &&
        !isFieldHidden(
          'serviceCreationPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="serviceCreationPercent"
            schema={schema?.serviceCreationPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.serviceCreationPercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  serviceCreationPercent: value,
                })
              }
            />
          </ProfileFieldName>
        )}

      {schema?.serviceChangeProductionPercent &&
        !isFieldHidden(
          'serviceChangeProductionPercent',
          props.estimateItem.positionType,
          props.profile,
        ) && (
          <ProfileFieldName
            controlId="serviceChangeProductionPercent"
            schema={schema?.serviceChangeProductionPercent}
            lang={props.lang}
          >
            <CurrencyControl
              value={props.estimateItem?.serviceChangeProductionPercent}
              percentage={true}
              decimalScale={12}
              disabled={props.readonly}
              onChange={value =>
                propertyChange({
                  serviceChangeProductionPercent: value,
                })
              }
            />
          </ProfileFieldName>
        )}
    </>
  );
};
